






import 'axios'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const axios = require('axios').default

// Want to use async/await? Add the `async` keyword to your outer function/method.
async function callBackend () {
  try {
    const response = await axios.get('https://api.jlkmedia.de/')
    console.log(response)
  } catch (error) {
    console.error(error)
  }
}

export default {
  name: 'Home',
  components: {},
  data: function () {
    return {
      status: false
    }
  },
  created: function (): void {
    console.log('hello')
    callBackend()
    this.data().status = true
  }
}
